import React from "react";
import New from "./New";
import { Link } from "react-router-dom";

function Whatweoffer() {
  const data = [
    {
      id: 1,
      img: "assets/images/services/services-1-1.jpg",
      name: "Saving money",
    },
    {
      id: 2,
      img: "assets/images/services/services-1-1.jpg",
      name: "Trusted partners",
    },
    {
      id: 3,
      img: "assets/images/services/services-1-1.jpg",
      name: "Mobile banking",
    },
    {
      id: 4,
      img: "assets/images/services/services-1-1.jpg",
      name: "Best Protective",
    },
  ];
  return (
    <>
      {/* <section className="service-one">
        <div className="container">
          <div className="sec-title text-center">
            <p className="sec-title__tagline">What We Offer</p>

            <h3 className="sec-title__title">
              Great insurance build better <br />
              future together
            </h3>
          </div>

          <div className="row gutter-y-60"> */}
            {/* {data.map((item) => (
            <div className="col-md-6 col-lg-3" key={item.id}>
              <div className="service-card">
                <div className="service-card__image">
                  <img src={item.img} />
                  <div className="service-card__hover">
                    <h3 className="service-card__title">
                      <Link to="/insurancesdetails">{item.name}</Link>
                    </h3>
                    <p className="service-card__text">
                      We denounce righ indignaties dislike men demoralize
                    </p>
                  </div>
                </div>

                <div className="service-card__content">
                  <h3 className="service-card__title">
                    <Link to="/insurancesdetails">{item.name}</Link>
                  </h3>
                </div>
              </div>
            </div>
          ))} */}
          {/* </div>
        </div>
      </section> */}

      <New />
    </>
  );
}

export default Whatweoffer;
